const LEGACY_TELEHEALTH_SEARCH_PATH = /^\/busca\/telemedicina\/([^/]+)\/?$/;

export function toTelehealthSearchPath(telehealthUrl: string): string | null {
  const [, slug] = new URL(telehealthUrl).pathname.match(LEGACY_TELEHEALTH_SEARCH_PATH) ?? [];

  return slug ? `/busca/${slug}/` : null;
}
